import type { Product } from '../types';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

const PRODUCT_TRAIT_ELIGIBILITY: Partial<Record<Product, keyof EditionAwarenessContextType>> = {
	jira: 'isEligibleForJswStandardToPremium',
	'jira-service-management': 'isEligibleForJsmStandardToPremium',
	'jira-product-discovery': 'isEligibleForJpdStandardToPremium',
	confluence: 'isEligibleForConfluenceStandardToPremium',
};

function getProductTraitEligibility(context: EditionAwarenessContextType): boolean {
	const traitKey = PRODUCT_TRAIT_ELIGIBILITY[context.product];
	return traitKey ? Boolean(context[traitKey]) : false;
}

export function isEligibleForStandardToPremium(context: EditionAwarenessContextType): boolean {
	const { edition, isInTrial, isInPredunning, userRoles, hasDismissedButton, onDismissButton } =
		context;

	return Boolean(
		isEditionOneOf(edition, ['standard']) &&
		// This trait will also check the supported products
		getProductTraitEligibility(context) &&
		userRoles?.includes('SITE_ADMIN') &&
		!isInTrial &&
		!isInPredunning &&
		hasDismissedButton === false &&
		typeof onDismissButton === 'function',
	);
}
